/**
 * Контракт резолва URL файла — ЕДИНСТВЕННЫЙ носитель правила «public_url → рабочая ссылка».
 *
 * `public_url` в БД намеренно относительный для файлов, отдаваемых нашим сервером
 * (local, s3-private → `/uploads/...`, `/api/filemanager/download/...`): запись не привязана
 * к хосту, одна и та же строка работает из dev, прода и любого домена. Хост дописывается
 * только в момент показа/отправки — этой функцией. Абсолютным `public_url` бывает лишь
 * у s3-public (чужой хост, CDN) — такой отдаётся как есть.
 *
 * Чистая функция без env: источник базы — забота адаптеров
 * (`client/fileUrl.ts` — apiBaseUrl браузера, `server/services/fileUrl.ts` — APP_URL).
 * Не дублируйте это правило по месту — импортируйте адаптер своего контекста.
 */

/** Абсолютный ли URL (http/https) — такие не префиксуются базой. */
export function isAbsoluteFileUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}

/**
 * Итоговый URL файла: абсолютный `public_url` — как есть, относительный — с префиксом базы.
 *
 * @param publicUrl - `public_url` из БД (или null/undefined — файла нет)
 * @param baseUrl - база контекста без завершающего слэша ('' — остаться относительным)
 * @returns готовая ссылка; '' если publicUrl пуст
 */
export function resolveFileUrl(publicUrl: string | null | undefined, baseUrl: string): string {
  if (!publicUrl) return '';
  if (isAbsoluteFileUrl(publicUrl)) return publicUrl;
  return `${baseUrl}${publicUrl}`;
}
